import type { PersistedState } from "redux-persist";

/** Slices the root store does not save. authentificationSlice is saved on its own, in localStorage. */
// paymentSlice: the payments page reads its lists again whenever it opens, so a stored copy would
// only flash old rows and cost a write on every change.
export const NOT_PERSISTED = ["authentificationSlice", "unsavedChangesSlice", "notificationSlice", "tenantSlice", "paymentSlice", "approvalSettingsSlice"];

/**
 * redux-persist leaves the blacklisted slices out when it saves, but rehydrates every key it finds in
 * storage. A copy saved before a slice was blacklisted, or in a slice's old shape (still in an open
 * tab after a deploy), would overwrite the slice: the tenant list crashed on the old tenantSlice.
 * Used as the root persist config's `migrate`, this drops them on the way in too.
 */
export const dropNotPersisted = async (state: PersistedState): Promise<PersistedState> => {
    if (!state) return state;
    const kept: Record<string, unknown> = { ...state };
    NOT_PERSISTED.forEach(key => { delete kept[key]; });
    return kept as PersistedState;
};
